import React from "react";
import { FaStar, FaShareAlt, FaDirections } from "react-icons/fa";

const HotelDetailHeader = ({ hotelName, address, city, hotelId, isMobile = false }) => {
    const mapQuery = encodeURIComponent(`${hotelName}, ${address || city}, Rajasthan`);

    const handleViewOnMap = () => {
        window.open(`https://www.google.com/maps/search/?api=1&query=${mapQuery}`, "_blank");
    };

    const handleShare = () => {
        const hotelUrl = `${window.location.origin}/HotelRoomsPage?id=${hotelId}`;
        const shareText = `Check out this amazing hotel: ${hotelName}!\n\n📍 Location: ${address || city}, Rajasthan\n\nBook now for the best rates: ${hotelUrl}`;
        if (navigator.share) {
            navigator.share({ title: hotelName, text: shareText, url: hotelUrl }).catch(() => {
                navigator.clipboard.writeText(hotelUrl);
            });
        } else {
            navigator.clipboard.writeText(hotelUrl).then(() => alert("Link copied to clipboard!"));
        }
    };

    return (
        <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between", alignItems: isMobile ? "flex-start" : "flex-end", flexWrap: "wrap", gap: isMobile ? "10px" : "20px" }}>
            <div style={{ minWidth: 0, width: isMobile ? "100%" : "auto" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                    {/* Star Rating */}
                    <div style={{ display: "flex", gap: "2px" }}>
                        {[1, 2, 3, 4, 5].map((s) => (
                            <FaStar key={s} size={12} color={s <= 4 ? "#FFC400" : "#ddd"} />
                        ))}
                    </div>
                    <span style={{
                        fontSize: isMobile ? "0.64rem" : "0.7rem",
                        color: "#EE2E24",
                        fontWeight: "900",
                        textTransform: "uppercase",
                        letterSpacing: "0.8px",
                        background: "rgba(238, 46, 36, 0.06)",
                        padding: "3px 10px",
                        borderRadius: "5px"
                    }}>
                        Trivana Verified
                    </span>
                </div>
                <h1 style={{
                    fontSize: isMobile ? "1.35rem" : "2.2rem",
                    fontWeight: "900",
                    color: "#1a1a1a",
                    margin: "8px 0",
                    letterSpacing: "-0.8px",
                    lineHeight: "1.1"
                }}>
                    {hotelName}
                </h1>
                <p style={{ margin: "0", color: "#666", fontSize: isMobile ? "0.78rem" : "0.9rem", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                    <FaDirections style={{ color: "#EE2E24" }} size={14} />
                    <span style={{ fontWeight: "600" }}>{address || city}, Rajasthan</span> <span style={{ display: isMobile ? "none" : "inline" }}>|</span> <span onClick={handleViewOnMap} style={{ color: "#EE2E24", cursor: "pointer", fontWeight: "800", textDecoration: "underline", fontSize: isMobile ? "0.75rem" : "0.85rem" }}>VIEW ON MAP</span>
                </p>
            </div>

            <div style={{ display: "flex", gap: "20px", alignItems: "center", width: isMobile ? "100%" : "auto", justifyContent: isMobile ? "flex-end" : "flex-start" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                    <button onClick={handleShare} style={{ background: "#fff", border: "1.5px solid #eee", borderRadius: "12px", width: isMobile ? "40px" : "44px", height: isMobile ? "40px" : "44px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#EE2E24", transition: "all 0.2s" }} onMouseOver={e => e.currentTarget.style.borderColor = "#EE2E24"} onMouseOut={e => e.currentTarget.style.borderColor = "#eee"}>
                        <FaShareAlt size={isMobile ? 16 : 18} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HotelDetailHeader;
